import BreadCrumbComponent from "Components/common/breadcrumb";
import { initialWelcomePopupState } from "Components/common/InitialWelcomePopup";
import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import userDetail from "Stores/userDetail";
import DashboardV2 from "./DashboardV2/DashboardV2";
import UserFilterDropdown from "./LiveFeed/Components/UserFilterDropdown";
import DashboardState from "./mainState";
// import TasksModule from "./TasksModule/main";
import {
  CopilotIntroPopup,
  CopilotIntroBanner
} from "Components/common/CopilotIntro";
import DashboardHeader from "./DashboardV2/DashboardHeader/DashboardHeader";
import DashboardTabsSkeleton from "./DashboardV2/DashboardHeader/DashboardTabsSkeleton";
import DateFilter from "./DashboardV2/DateFilter/DateFilter";
import dashboardV2Store from "./DashboardV2/store/dashboardV2Store";
import widgetDataStore from "./DashboardV2/store/widgetDataStore";
import LiveFeed from "./LiveFeed/main";

export const DASHBOARD_MEMBER_FILTER_KEY = "dashboard-member-filter";

const Dashboard = observer(props => {
  const breadcrumbArr = [
    {
      name: "Dashboard",
      link: "/dashboard"
    }
  ];
  const {
    team = false,
    memberId = "",
    hasTeamMember = false,
    isTeamOwner = false
  } = userDetail?.userInfo || {};

  const { noOfSequencesUsed = 0, isOnBoardingCompleted = false } =
    userDetail.userFeatureFlag || {};

  const readPersistedMemberFilter = () => {
    try {
      const raw = localStorage.getItem(DASHBOARD_MEMBER_FILTER_KEY);
      if (raw == null) return null;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed) && "ids" in parsed) {
        return parsed;
      }
      return { ids: parsed, label: undefined, filterType: undefined };
    } catch (e) {
      localStorage.removeItem(DASHBOARD_MEMBER_FILTER_KEY);
      return null;
    }
  };
  const persistedMemberFilter = readPersistedMemberFilter();

  const restoredMemberFilterRef = useRef(false);
  if (!restoredMemberFilterRef.current) {
    restoredMemberFilterRef.current = true;
    if (persistedMemberFilter && persistedMemberFilter.ids !== undefined) {
      DashboardState.setMemberId(persistedMemberFilter.ids);
    }
  }

  const initialSelectedUser =
    persistedMemberFilter && persistedMemberFilter.label != null
      ? persistedMemberFilter.label
      : undefined;
  const initialFilterType =
    persistedMemberFilter && persistedMemberFilter.filterType != null
      ? persistedMemberFilter.filterType
      : undefined;

  const getSelectedUsers = obj => {
    const memberIds =
      obj && typeof obj === "object" && Object.keys(obj)?.length > 0
        ? obj
        : obj?.length && obj?.toLowerCase() === "you"
          ? new Array(memberId)
          : "";
    return memberIds;
  };

  const getSelectedUser = (value, selectedUserLabel, filterType) => {
    const selectedIds = getSelectedUsers(value);
    DashboardState.setMemberId(selectedIds);
    try {
      localStorage.setItem(
        DASHBOARD_MEMBER_FILTER_KEY,
        JSON.stringify({ ids: selectedIds, label: selectedUserLabel, filterType: filterType || "" })
      );
    } catch (e) {}
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const dashboardContainerRef = useRef(null);
  const hasPinnedWidgets = dashboardV2Store.activeDashboard?.widgets?.some(w => w.pinned) || false;

  const handleDashboardScroll = e => {
    const el = e.target;
    setIsScrolled(el.scrollTop > 0);
    setShowBottomShadow(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
  };

  useEffect(() => {
    const el = dashboardContainerRef.current;
    if (el) setShowBottomShadow(el.scrollHeight > el.clientHeight);
  }, [dashboardV2Store.activeDashboard?.widgets?.length]);

  useEffect(() => {
    const isWelcomePopupShown = localStorage.getItem("isWelcomePopupShown");
    if (
      !isOnBoardingCompleted &&
      !isWelcomePopupShown &&
      !noOfSequencesUsed > 0
    ) {
      localStorage.setItem("isWelcomePopupShown", true);
      initialWelcomePopupState.setShowPopup(true);
    }
    return () => {
      DashboardState.setMemberId("");
    };
  }, []);

  const copilotDisabled = userDetail?.featuresDisabled?.includes("COPILOT");

  return (
    <section className="dashboardPage">
      <div className="headerSection">
        <BreadCrumbComponent breadCrumbValue={breadcrumbArr} />
      </div>
      {!copilotDisabled && <CopilotIntroPopup />}
      <div className="dashboardWrapper">
        {!copilotDisabled && <CopilotIntroBanner />}
        <div className={`filterSectionWrap${isScrolled ? " filterSectionWrapScrolled" : ""}`}>
          <div className="filterSectionInner">
            <div className="dashboardTabsContainer">
              {dashboardV2Store.isLoadingDashboards ? (
                <DashboardTabsSkeleton />
              ) : (
                <DashboardHeader />
              )}
            </div>
            <div className="topFilter">
              <DateFilter
                activeFilter={widgetDataStore.activeDateFilter}
                onSelect={preset => widgetDataStore.setDateFilter(preset)}
              />
              {((team && hasTeamMember?.length > 1) || isTeamOwner) && (
                <UserFilterDropdown
                  team={team}
                  selectedUserCbk={getSelectedUser}
                  initialSelectedUser={initialSelectedUser}
                  initialFilterType={initialFilterType}
                />
              )}
            </div>
          </div>
        </div>
        <div className="dashboardContainer" ref={dashboardContainerRef} onScroll={handleDashboardScroll}>
          <div className="leftSection">
            <DashboardV2 />
          </div>
          <div className={`rightSectionWrap${hasPinnedWidgets ? " rightSectionWrapWithPinned" : ""}`}>
            <div className="rightSection liveFeedSettingBarWeb">
              <LiveFeed />
            </div>
          </div>
        </div>
        {showBottomShadow && <span className="dashboardContainerShadowBottom" />}
      </div>
    </section>
  );
});

export default withRouter(Dashboard);
export { Dashboard };

